import { render, staticRenderFns } from "./SelectGame.vue?vue&type=template&id=1b01e309&scoped=true"
import script from "./SelectGame.vue?vue&type=script&lang=js"
export * from "./SelectGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b01e309",
  null
  
)

export default component.exports